const debug = true
const allList = ["af","sq","am","ar","hy","az","bn","bs","bg","ca","zh","zh-Hant","hr","cs","da","nl","et","en","fa","fil","fi","fr","ka","de","el","gu","ht","ha","he","hi","hu","is","id","ga","it","ja","kn","kk","ko","lv","lt","mk","ms","ml","mt","mr","mn","no","ps","pl","pt","pa","ro","ru","sr","si","sk","sl","so","es","sw","sv","ta","te","th","tr","uk","ur","uz","vi","cy", "sq"]

export default {
	debug: debug,
	home: debug ? "https://dev-www.germantutor.ai" : "https://www.germantutor.ai",
	domain: debug ? "https://dev-talk.germantutor.ai" : "https://talk.germantutor.ai",
	host: debug ? "https://dev-api.germantutor.ai/" : 'https://api.germantutor.ai/',
	package: 'calteacher',
	requestVersion: "2.2.0",
	platform: "web",
	version: '2.2.0',
	base: debug ? "https://d1d1uea3ze2mn9.cloudfront.net/" : "https://d35zd80xmucndw.cloudfront.net/",
	allList: allList,
	googleClientID: "915004147730-u7462f66193grmbjjh8m0keqp32e9ioi.apps.googleusercontent.com",
	appleClientID: "com.germantutor.web"
}
